import { TextMessageTaxIdType } from "type/text-message-tax-id";

const digits = (value?: string | null) => (value || "").replace(/\D/g, "");

/**
 * The nine digits, ignoring spaces and hyphens, the same way the server reads them. A pasted Canadian program account
 * (123456789 RT0001) keeps its business number; any other extra digit is kept, so the number fails validation.
 */
export const normalizeTaxId = (value?: string | null) => {
	const compact = (value || "").replace(/[\s-]/g, "");
	const programAccount = /^(\d{9})RT\d{4}$/i.exec(compact);
	return programAccount ? programAccount[1] : digits(compact);
};

export const isValidTaxId = (value?: string | null) => normalizeTaxId(value).length === 9;

/** The same shape the server's textMessageTaxIdMasked uses. */
export const maskTaxId = (value: string | null | undefined, type: TextMessageTaxIdType) => {
	const last4 = normalizeTaxId(value).slice(-4);
	return type === "CBN" ? `XXXXX${last4}` : `XX-XXX${last4}`;
};

const phoneDigits = (value?: string | null) => {
	const d = digits(value);
	return (d.length === 11 && d.startsWith("1") ? d.slice(1) : d).slice(0, 10);
};

/** "(123) 456-7890" as the client types, capped at 10 digits; a stored +1 prefix is dropped. */
export const formatPhoneInput = (value?: string | null) => {
	const d = phoneDigits(value);
	if (d.length < 4) {
		return d;
	}
	if (d.length < 7) {
		return `(${d.slice(0, 3)}) ${d.slice(3)}`;
	}
	return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

export const isValidPhone = (value?: string | null) => phoneDigits(value).length === 10;
